import { BenAdminOption, TechCreditOption } from "./types";

export const BenAdminMappingText: Record<BenAdminOption, string> = {
  employeeNavigator: "Employee Navigator",
  ease: "Ease",
  bSwift: "BSwift",
  adp: "ADP",
  planSource: "PlanSource",
  paychex: "Paychex",
  triNet: "TriNet",
  rippling: "Rippling",
  paylocity: "Paylocity",
  selerix: "Selerix",
  zenefits: "Zenefits",
  workday: "Workday",
  paycom: "Paycom",
  other: "Other",
};

export const TechCreditOptions: { label: string; value: TechCreditOption }[] = [
  { label: "Percentage", value: "percentage" },
  { label: "Dollar Amount", value: "dollarAmount" },
  { label: "PEPM", value: "pepm" },
  { label: "Carrier Standard", value: "carrierStandard" },
];

export const BenAdminOptions: { label: string; value: BenAdminOption }[] = [
  { label: "Employee Navigator", value: "employeeNavigator" },
  { label: "Ease", value: "ease" },
  { label: "BSwift", value: "bSwift" },
  { label: "ADP", value: "adp" },
  { label: "PlanSource", value: "planSource" },
  { label: "Paychex", value: "paychex" },
  { label: "TriNet", value: "triNet" },
  { label: "Rippling", value: "rippling" },
  { label: "Paylocity", value: "paylocity" },
  { label: "Selerix", value: "selerix" },
  { label: "Zenefits", value: "zenefits" },
  { label: "Workday", value: "workday" },
  { label: "Paycom", value: "paycom" },
  { label: "Other", value: "other" },
];
